export default "__VITE_ASSET__943b39ee__"